export enum CurveCategory {
  CROP = 'crop',
  ZIP = 'zip',
  SPACER = 'spacer',
  EMBOSSING_BORDER = 'embossing_border',
}
